require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-15-of-the-best-cbd-brands-on-shopify.json") })
        }
      }, "path---blog-15-of-the-best-cbd-brands-on-shopify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-15-of-the-best-cbd-brands-on-shopify!./.cache/json/blog-15-of-the-best-cbd-brands-on-shopify.json
// module id = 384
// module chunks = 231608221292675